import { compose, setDisplayName, pure, withState, lifecycle } from 'recompose';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { withErrors, withModal } from 'recompose-extends';

import Header from '../../views/Header';
import { selectHeader, selectUser, selectQuery } from '../../../selectors';
import { loadHeader, logout, enterSearch, resetSearch } from '../../../actions';
import Search from '../Search';

export default compose(
  setDisplayName('HeaderContainer'),
  withErrors(),
  withState('fixed', 'setFixed', true),
  withState('widget', 'setWidget', true),
  withState('showSearch', 'setShowSearch', false),
  connect(
    createSelector(
      selectHeader(),
      selectUser(),
      selectQuery(),
      (headerMenu, user, query) => ({
        headerMenu,
        user,
        query
      })
    ),
    {
      loadHeader,
      logout,
      enterSearch,
      resetSearch
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.loadHeader(this.props.user.typology);
    }
  }),
  withModal(
    ({ showSearch }) => showSearch,
    Search,
    ({ setShowSearch }) => ({
      onClose: () => {
        resetSearch();
        setShowSearch(false);
      }
    })
  ),
  pure
)(Header);
